import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery, useMutation } from "react-query";
import { QueryKeys } from "../queryKeys";

export type AnnulmentQueriesListRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  status?: string;
  id?: number;
  merchantId?: string | null;
  merchantName?: string;
  globalMerchantId?: string;
  taxNo?: string;
  merchantStatus?: string;
  viewStatus?: boolean;
  [key: string]: any;
}

interface AnnulmentQueriesListResponse {
  data: any;
  // Add other response properties as needed
}

async function annulmentQueriesList(request: AnnulmentQueriesListRequest): Promise<AnnulmentQueriesListResponse> {
  try {
    return (await axiosInstance.post("/Merchant/AnnulmentQueriesList", request)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAnnulmentQueriesList(data: AnnulmentQueriesListRequest) {
  return useQuery<AnnulmentQueriesListResponse, Error>(
    [QueryKeys.AnnulmentQueriesList, data],
    () => annulmentQueriesList(data)
  );
}

export function useAnnulmentQueriesListMutation() {
  return useMutation<AnnulmentQueriesListResponse, Error, AnnulmentQueriesListRequest>(
    (data) => annulmentQueriesList(data)
  );
}
